
import DropArea from './dropArea';

import SignMinus from './images/icon-minus.svg';
import SignPlus from './images/icon-plus-big.svg';
import SignEquals from './images/icon-equals.svg';

import './styles.css';

export default function TransactionRecordsBody({
  options,
  value,
  onChangeItemDrop,
  onCoreItemDrop,
  onDropAreaChange,
  resetKey,
  incorrectDecisions,
  isItemsDisabled,
  selectedDesignTypes,
  tutorialRestrictions,
  // Instructor-picked equation on the scenario level ('assets' |
  // 'equity' | null). When set, overrides the design-based rule below
  // so instructors can force the additive `A = L + E` form on levels
  // that would otherwise render subtractively — or vice versa. Null
  // for legacy levels created before this field existed, which keep
  // the original design-driven behavior.
  equation,
  optionsToBeFilled
}) {
  // Equation field takes precedence when set. Otherwise fall back to
  // the legacy rule: design '2' (Debit/Credit chips) → additive form.
  const showSecondFormula = equation === 'assets'
    ? true
    : equation === 'equity'
      ? false
      : selectedDesignTypes?.includes('2');

  const renderSection = (index) => (
    <div className="equation-section">
      <h4>{options[index]?.name}</h4>
      <DropArea
        option={options[index]}
        value={value}
        onChangeItemDrop={onChangeItemDrop}
        onCoreItemDrop={onCoreItemDrop}
        onDropAreaChange={onDropAreaChange}
        resetKey={resetKey}
        incorrectDecisions={incorrectDecisions.filter(incorrectDecision => incorrectDecision.optionAccountItemId === options[index]?.accountItemId)}
        isItemsDisabled={isItemsDisabled}
        selectedDesignTypes={selectedDesignTypes}
        tutorialRestrictions={tutorialRestrictions}
        optionsToBeFilled={optionsToBeFilled}
      />
    </div>
  );

  return (
    <div className="transaction-records-body">
      <div className="equation-cards-row">
        {renderSection(0)}
        <img
          className="equation-divider"
          src={showSecondFormula ? SignEquals : SignMinus}
          alt={showSecondFormula ? "Equals" : "Minus"}
        />
        {renderSection(1)}
        <img
          className="equation-divider"
          src={showSecondFormula ? SignPlus : SignEquals}
          alt={showSecondFormula ? "Plus" : "Equals"}
        />
        {renderSection(2)}
      </div>
    </div>
  );
}
